import axios from "axios";
import {endpoint} from "../../config/app.config";
import { clearCookie, getCookie, setParentDomainCookie } from "../../utils/cookies";

const { token, reset, sub, user } = getCookie()

export const postUserFeedback = (userInput) => {
  clearCookie()
  return axios
    .post(`${endpoint}/api/feedback`, userInput, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response;
    })
    .catch((err) => {
      throw err;
    });
};

export const getFeedbackQuestion = () => {
  clearCookie()
  return axios
    .get(`${endpoint}/api/feedback/question`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
};
